import React, { useMemo } from 'react';
import WebsiteImage from 'components/WebsiteImage';
import RichText from 'components/RichText';

import { FeaturedContentContainer } from './styles';

const InPageFeaturesV5FeaturedContent = ({ description, featuredImage, title }) => {
  const imageElement = useMemo(() => <WebsiteImage {...featuredImage} />, []);
  
  return (
    <FeaturedContentContainer>
      <div className="in-page-features-v5--featured-content-img">{imageElement}</div>
      <h2>{title}</h2>
      <RichText content={description} />
    </FeaturedContentContainer>
  );
};

export default InPageFeaturesV5FeaturedContent;
